import sentinelImage from './img/card-front-shaped-final.svg'
import threePackImage from './img/sentinel-nfc-3-pack.png'
import { CartItemSlot } from '../CartItemSlot'
import { CartItem } from '../CartItem'

export const cartItemsNft = new Map<CartItemSlot, CartItem>()

cartItemsNft.set(CartItemSlot.Primary, {
  COGS: 1,
  defaultAdd: true,
  image: sentinelImage,
  msrp: 50,
  note: 'Each cryptographic NFC card is individually programmed with data allowing it to be used with the COIN app.<br>**Requires NFC compatibility. Not compatible with iPhone 5, 6, 6+ or SE (2016), and some older Android Devices.',
  planId: 'XYO-SENTINEL-NFC-01',
  price: 0,
  quantity: 1,
  ship: true,
  subtitle: '(Normal Price: $50)',
  title: '1 SentinelX NFC Device:',
  value: 0,
  name: '1 SentinelX NFC Device: Free',
})

cartItemsNft.set(CartItemSlot.Shipping, {
  COGS: 0.68,
  defaultAdd: true,
  msrp: 12.95,
  planId: 'XY-SHIPPING-FULL-2',
  price: 12.95,
  quantity: 1,
  ship: true,
  title: 'Shipping Cost: $12.95',
  name: '$12.95 (price you pay)',
  value: 12.95,
})

cartItemsNft.set(CartItemSlot.ShippingIntl, {
  COGS: 2.65,
  msrp: 17.95,
  planId: 'XY-SHIPPING-INTL-1',
  price: 17.95,
  quantity: 1,
  ship: true,
  subtitle: '(US $12.95)',
  title: 'Shipping Cost: $17.95 (price you pay)',
  value: 17.95,
})

cartItemsNft.set(CartItemSlot.Trial, {
  COGS: 0,
  defaultAdd: true,
  title: 'Earn 36x more rewards with COIN Pro (3-Day Trial)',
  name: 'COIN Pro (3-Day Trial)',
  // subtitle: '($34.95/mo after trial, cancel anytime)',
  planId: 'XYO-COIN-PRO-3D-TRIAL-34-95',
  planType: 'COIN Pro',
  price: 0,
  quantity: 1,
  ship: false,
  value: 42,
})

cartItemsNft.set(CartItemSlot.Subscription, {
  COGS: 0,
  planId: 'XYO-COIN-PRO-34-95',
  planType: 'COIN Pro',
  price: 34.95,
  quantity: 1,
  ship: false,
  value: 34.95,
})

cartItemsNft.set(CartItemSlot.Upsell, {
  COGS: 3,
  image: threePackImage,
  planId: 'XYO-SENTINEL-NFC-3-PACK-01',
  price: 67,
  quantity: 1,
  ship: true,
  value: 67,
})
cartItemsNft.set(CartItemSlot.NFT, {
  COGS: 0,
  defaultAdd: true,
  image: 'https://pickaxes.coinapp.co/images/unrevealed/500x500.png',
  planId: 'RANDOM-MINT-0-00',
  title: 'Custom Pickaxe',
  name: 'Custom Pickaxe',
  subtitle: 'Common, Uncommon (1/100), Rare (1/1k), Epic (1/10k), Legendary (1/100k)',
  note: 'Custom Pickaxe is required to be minted as an NFT within 30 days to activate its enhancements.',
  price: 0,
  quantity: 1,
  ship: false,
  value: 0,
})
